// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"11ca4181","471":"fb7bc144","496":"83004000"}[chunkId] + ".chunk.js";
};